var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIran(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2511_3475)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 0.000488281H0V31.9998H32V0.000488281Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 0H0V10.6664H32V0Z",
    fill: "#239F40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 21.3336H0V32.0001H32V21.3336Z",
    fill: "#DA0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8076 19.2162C14.6092 19.4767 15.4763 19.4515 16.2615 19.145C17.0467 18.8386 17.7015 18.2697 18.1147 17.535C18.5278 16.8004 18.6739 15.9453 18.528 15.1152C18.3821 14.285 17.9533 13.531 17.3143 12.9813C17.7301 13.5964 17.9664 14.3152 17.9968 15.0571C18.0272 15.7989 17.8505 16.5346 17.4866 17.1817C17.1226 17.8289 16.5857 18.362 15.9359 18.7213C15.2862 19.0806 14.5492 19.252 13.8076 19.2162Z",
    fill: "#DA0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4733 18.5164C19.0001 18.2119 19.4241 17.757 19.6908 17.21C19.9575 16.6631 20.0548 16.049 19.9703 15.4464C19.8858 14.8437 19.6233 14.2801 19.2164 13.8276C18.8095 13.3751 18.2768 13.0544 17.6865 12.9066C18.1071 13.2228 18.4612 13.6189 18.7285 14.0722C18.9957 14.5255 19.1709 15.0271 19.244 15.5482C19.3171 16.0693 19.2866 16.5998 19.1544 17.1091C19.0221 17.6184 18.7907 18.0966 18.4733 18.5164Z",
    fill: "#DA0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 19.8707L15.7998 15.8708L15.9998 12.7217C16.1213 12.8915 16.2837 13.0278 16.4719 13.1181V15.4692L16.311 19.4424L15.9998 19.8707Z",
    fill: "#DA0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9199 12.4708L15.9999 12.546C16.0813 12.6617 16.2023 12.7434 16.34 12.7758C16.4777 12.8081 16.6225 12.7888 16.7469 12.7215C16.8713 12.6541 16.9666 12.5434 17.0148 12.4104C17.063 12.2774 17.0606 12.1314 17.0082 12C16.9876 12.1094 16.9339 12.2099 16.8545 12.2879C16.7751 12.366 16.6737 12.4179 16.564 12.4366C16.4542 12.4554 16.3413 12.4401 16.2405 12.3929C16.1397 12.3456 16.0557 12.2686 15.9999 12.1723",
    fill: "#DA0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1924 19.2162C17.3908 19.4767 16.5237 19.4515 15.7385 19.145C14.9533 18.8386 14.2985 18.2697 13.8853 17.535C13.4722 16.8004 13.3261 15.9453 13.472 15.1152C13.6179 14.285 14.0467 13.531 14.6857 12.9813C14.2699 13.5964 14.0336 14.3152 14.0032 15.0571C13.9728 15.7989 14.1495 16.5346 14.5134 17.1817C14.8774 17.8289 15.4143 18.362 16.0641 18.7213C16.7138 19.0806 17.4508 19.252 18.1924 19.2162Z",
    fill: "#DA0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5267 18.5164C12.9999 18.2119 12.5759 17.757 12.3092 17.21C12.0425 16.6631 11.9452 16.049 12.0297 15.4464C12.1142 14.8437 12.3767 14.2801 12.7836 13.8276C13.1905 13.3751 13.7232 13.0544 14.3135 12.9066C13.8929 13.2228 13.5388 13.6189 13.2715 14.0722C13.0043 14.5255 12.8291 15.0271 12.756 15.5482C12.6829 16.0693 12.7134 16.5998 12.8456 17.1091C12.9779 17.6184 13.2093 18.0966 13.5267 18.5164Z",
    fill: "#DA0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 19.8707L16.2002 15.8707L16.0002 12.7217C15.8787 12.8914 15.7163 13.0278 15.5281 13.118V15.4691L15.689 19.4423L16.0002 19.8707Z",
    fill: "#DA0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0801 12.4708L16.0001 12.546C15.9187 12.6617 15.7977 12.7434 15.66 12.7758C15.5223 12.8081 15.3775 12.7888 15.2531 12.7215C15.1287 12.6541 15.0334 12.5434 14.9852 12.4104C14.937 12.2774 14.9394 12.1314 14.9918 12C15.0124 12.1094 15.0661 12.2099 15.1455 12.2879C15.2249 12.366 15.3263 12.4179 15.436 12.4366C15.5458 12.4554 15.6587 12.4401 15.7595 12.3929C15.8603 12.3456 15.9443 12.2686 16.0001 12.1723",
    fill: "#DA0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.05371 8.19457H2.00507M-2.85914 9.94568V8.97284H-1.30259V9.75112H0.253953V8.97284H-0.718889M-2.27544 9.75112H-1.8863M2.00507 9.75112H1.03223V8.97284H2.58877M2.58877 8V9.75112H4.14532V8M3.36705 8V9.75112",
    stroke: "white",
    strokeWidth: 0.389137
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.05371 10.724H0.448521M0.837658 10.724H4.33989",
    stroke: "white",
    strokeWidth: 0.778274
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.05371 21.4012H0.448521M0.837658 21.4012H4.33989",
    stroke: "white",
    strokeWidth: 0.778274
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.05371 22.3742H2.00507M-2.85914 24.1253V23.1525H-1.30259V23.9307H0.253953V23.1525H-0.718889M-2.27544 23.9307H-1.8863M2.00507 23.9307H1.03223V23.1525H2.58877M2.58877 22.1796V23.9307H4.14532V22.1796M3.36705 22.1796V23.9307",
    stroke: "white",
    strokeWidth: 0.389137
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.72461 8.19457H9.78339M4.91918 9.94568V8.97284H6.47573V9.75112H8.03227V8.97284H7.05943M5.50288 9.75112H5.89202M9.78339 9.75112H8.81055V8.97284H10.3671M10.3671 8V9.75112H11.9236V8M11.1454 8V9.75112",
    stroke: "white",
    strokeWidth: 0.389137
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.72461 10.724H8.22684M8.61598 10.724H12.1182",
    stroke: "white",
    strokeWidth: 0.778274
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.72461 21.4012H8.22684M8.61598 21.4012H12.1182",
    stroke: "white",
    strokeWidth: 0.778274
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.72461 22.3742H9.78339M4.91918 24.1253V23.1525H6.47573V23.9307H8.03227V23.1525H7.05943M5.50288 23.9307H5.89202M9.78339 23.9307H8.81055V23.1525H10.3671M10.3671 22.1796V23.9307H11.9236V22.1796M11.1454 22.1796V23.9307",
    stroke: "white",
    strokeWidth: 0.389137
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5068 8.19457H17.5656M12.7014 9.94568V8.97284H14.258V9.75112H15.8145V8.97284H14.8417M13.2851 9.75112H13.6742M17.5656 9.75112H16.5928V8.97284H18.1493M18.1493 8V9.75112H19.7059V8M18.9276 8V9.75112",
    stroke: "white",
    strokeWidth: 0.389137
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5068 10.724H16.0091M16.3982 10.724H19.9004",
    stroke: "white",
    strokeWidth: 0.778274
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5068 21.4012H16.0091M16.3982 21.4012H19.9004",
    stroke: "white",
    strokeWidth: 0.778274
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5068 22.3742H17.5656M12.7014 24.1253V23.1525H14.258V23.9307H15.8145V23.1525H14.8417M13.2851 23.9307H13.6742M17.5656 23.9307H16.5928V23.1525H18.1493M18.1493 22.1796V23.9307H19.7059V22.1796M18.9276 22.1796V23.9307",
    stroke: "white",
    strokeWidth: 0.389137
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2871 8.19457H25.3459M20.4817 9.94568V8.97284H22.0382V9.75112H23.5948V8.97284H22.6219M21.0654 9.75112H21.4545M25.3459 9.75112H24.373V8.97284H25.9296M25.9296 8V9.75112H27.4861V8M26.7079 8V9.75112",
    stroke: "white",
    strokeWidth: 0.389137
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2881 10.724H23.7903M24.1795 10.724H27.6817",
    stroke: "white",
    strokeWidth: 0.778274
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2881 21.4012H23.7903M24.1795 21.4012H27.6817",
    stroke: "white",
    strokeWidth: 0.778274
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2881 22.3742H25.3469M20.4827 24.1253V23.1525H22.0392V23.9307H23.5957V23.1525H22.6229M21.0664 23.9307H21.4555M25.3469 23.9307H24.374V23.1525H25.9306M25.9306 22.1796V23.9307H27.4871V22.1796M26.7088 22.1796V23.9307",
    stroke: "white",
    strokeWidth: 0.389137
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0752 8.19457H33.134M28.2698 9.94568V8.97284H29.8263V9.75112H31.3829V8.97284H30.41M28.8535 9.75112H29.2426M33.134 9.75112H32.1611V8.97284H33.7177M33.7177 8V9.75112H35.2742V8M34.496 8V9.75112",
    stroke: "white",
    strokeWidth: 0.389137
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0742 10.724H31.5765M31.9656 10.724H35.4678",
    stroke: "white",
    strokeWidth: 0.778274
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0742 21.4012H31.5765M31.9656 21.4012H35.4678",
    stroke: "white",
    strokeWidth: 0.778274
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0742 22.374H33.133M28.2688 24.1251V23.1523H29.8253V23.9306H31.3819V23.1523H30.409M28.8525 23.9306H29.2416M33.133 23.9306H32.1602V23.1523H33.7167M33.7167 22.1794V23.9306H35.2733V22.1794M34.495 22.1794V23.9306",
    stroke: "white",
    strokeWidth: 0.389137
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2511_3475"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIran);
export default __webpack_public_path__ + "static/media/Iran.a5e07e53f0890e363599f9225055c4f3.svg";
export { ForwardRef as ReactComponent };